import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../components/ui/SearchableSelect/constants';
import useInterveneSx from '../hooks/useInterveneSx';
import { mergeSlotProps } from '../../../components/ui/SearchableSelect/selectUtils';

export default function InterveneSearchableSelect({
  sx,
  slotProps,
  variant = 'channel',
  ...props
}) {
  const interveneSx = useInterveneSx();
  const isChannel = variant === 'channel';
  const styles = isChannel ? interveneSx.channelField : interveneSx.searchField;

  return (
    <SearchableSelect
      {...props}
      mode={props.mode || SELECT_MODE.STATIC}
      size={props.size || 'small'}
      sx={{
        ...(isChannel ? styles : styles.root),
        ...sx,
      }}
      slotProps={mergeSlotProps(
        isChannel ? {} : styles.slotProps || {},
        slotProps
      )}
    />
  );
}
